import React, { Component } from 'react';
import { Tabs, Toast } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import $ from "jquery";
import { Customgy } from "../../common/customgy";
import { Item } from "./item";
import './style.less';
export default class PackageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: this.props.match.params,
            cardid: this.props.match.params.cardid,
            TabItem: [],
            TabTitle: [],
            checkItem: [],

            tabs2: [],
            crmPack: [],
            mpPack: [],
            oid: 0,
            iscustomize: true,

        }
    }
    componentDidMount() {
        
        let tabs2 = [];
        let ids = [];
        if (localStorage.getItem('orderment') !== null) {
            let orderment = JSON.parse(localStorage.getItem('orderment'));
            if (orderment.ids !== '' && orderment.packageType === 1) {
                ids = orderment.ids.split(',');
            }
        }
        services.GetMidcailConfig(this.state.params.mcno, '').then(datam => {
            if (datam.status === 0) {
                this.setState({ iscustomize: !!datam.result.iscustomize });             
                if (!!datam.result.iscustomize) {
                    let parameter={McNO:this.state.params.mcno,peopleId:this.state.params.peopleId}
                    services.GetListbyitem(parameter, '正在查询，请稍后').then(value => {        
                        if (value.status === 0) {
                            let TabTitle = [];
                            let TabItem = [];
                            let checkItem = [];
                            value.result.forEach((element, index) => {
                                TabTitle.push({ name: element.shortname, title: element.shortname + '(' + element.children.length + ')', key: 't' + element.itemtypeid, id: index, num: element.children.length });
                                let cm = element.children;
                                cm.forEach((val2,cindex) => {
                                    if (val2.chooseid === 1) {
                                        val2['checked'] = 2;
                                         checkItem.push(val2);
                                    } else if (ids.length > 0) {                                       
                                        if (!!(ids.find(d => parseInt(d) === parseInt(val2.itemid)))) {
                                            val2['checked'] = 1;
                                            checkItem.push(val2);
                                        } else {
                                            val2['checked'] = 0;
                                        }
                                    } else {
                                        val2['checked'] = 0;
                                    }
                                    if (val2.bindChildren.length > 0) {
                                        val2.bindChildren.forEach((data3) => {
                                            if (data3.bindId === 0) {
                                           
                                                data3.mid = cm[cindex].itemid;
                                                data3.mname = cm[cindex].itemname;
                                            }
                                            if (val2.checked === 1) {
                                                if (data3.bindId === 1) {
                                                    let c = cm.find((element) => element.itemid === data3.bindItemId);
                                                    if (c !== undefined) {
                                                        c.checked = 3;
                                                    }
                                                }
                                            }
                                        })
                                    }

                                })
                                TabItem.push(cm);
                            });
                            TabItem = value.result;
                            checkItem.forEach(element => {
                                if(element.bindChildren.length >0 )
                                {
                                    element.bindChildren.forEach(val => {
                                        if(val.bindId === 1)
                                        {
                                            TabItem.forEach(item => {
                                                let cm = item.children;
                                                cm.forEach((item2) => {
                                                    if(item2.itemid === val.bindItemId)
                                                    {
                                                        item2.checked=3;
                                                    }                                                    
                                                })
                                            })
                                        }
                                    })
                                }                                
                            });
                            this.setState({ TabTitle: TabTitle, TabItem: TabItem, checkItem: checkItem }, () => {
                            });
                        } else {
                            Toast.offline(value.message);
                        }
                    })
                }
                services.GetPacklist2(this.state.params, '').then(data => {
                    if (data.status === 0) {
                        if (data.result.crmPack.length === 0) {
                            let cm = { title: '1+x套餐', sub: '2' };
                            tabs2 = [
                                { title: '标准套餐', sub: '1' }
                            ];
                            if (!!datam.result.iscustomize) {
                                tabs2.push(cm);
                            }
                        } else {
                            let cm = { title: '1+x套餐', sub: '3' };
                            tabs2 = [
                                { title: '专属套餐', sub: '1' },
                                { title: '标准套餐', sub: '2' },
                            ];
                            if (!!datam.result.iscustomize) {
                                tabs2.push(cm);
                            }
                        }
                        this.setState({ tabs2: tabs2, crmPack: data.result.crmPack, mpPack: data.result.mpPack });
                    } else {
                        Toast.offline(data.message);
                    }

                });
            } else {
                Toast.offline(datam.message, 2);
            }
        });
       
        window.addEventListener('scroll', this.handleScroll);
    }    
    onTabClick = (tab, index) => {
        this.setState({
            oid: index
        });
        $("html,body").animate({
            scrollTop: 0
        }, 0);
    }

    render() {
        const { TabTitle, TabItem, checkItem, tabs2, crmPack, mpPack, cardid } = this.state;
        return <div className="orderpackage"><CommonlyHeadMembers barname="体检套餐" />
            <div className="searchbox">
                {/* <SearchBar placeholder="请输入套餐名称" maxLength={20} /> */}
                {
                    tabs2.length > 0 ?
                        <Tabs tabs={tabs2}
                            page={this.state.oid}
                            onTabClick={(tab, index) => { this.onTabClick(tab, index) }}
                            onChange={(tab, index) => { this.onTabClick(tab, index) }}
                            tabBarPosition="top"
                            useOnPan={true}
                            swipeable={true}
                            tabBarBackgroundColor={'none'}
                            tabBarActiveTextColor={'#ffffff'}
                            tabBarInactiveTextColor={'#ffffff'}
                        >
                            {
                                tabs2.map((data, index) => (
                                    <div key={'tab' + index}    style={{ height: document.documentElement.clientHeight - 60, backgroundColor: '#ffffff' }}>
                                        {
                                            tabs2.length === 3 ?
                                                <div  >
                                                    {index === 0 ? <Item crmPack={crmPack} cardid={cardid} mcno={this.state.params.mcno} /> : ''}
                                                    {index === 1 ? <Item mpPack={mpPack} cardid={cardid} mcno={this.state.params.mcno} /> : ''}
                                                    {index === 2 && TabTitle.length > 0  ? <Customgy TabTitle={TabTitle} TabItem={TabItem} checkItem={checkItem} cardid={cardid} mcno={this.state.params.mcno} packageid={0} handleScroll={this.handleScroll}  /> : ''
                                                    }
                                                </div>
                                                : ''
                                        }
                                        {
                                            tabs2.length === 2 && !!this.state.iscustomize ?
                                                <div>
                                                    {index === 0 ? <Item mpPack={mpPack} cardid={cardid} mcno={this.state.params.mcno} /> : ''}
                                                    {index === 1  && TabTitle.length > 0  ?  <Customgy TabTitle={TabTitle} TabItem={TabItem} checkItem={checkItem} cardid={cardid} mcno={this.state.params.mcno} packageid={0} handleScroll={this.handleScroll}  /> : ''
                                                    }
                                                </div>
                                                : ''
                                        }
                                        {
                                            tabs2.length === 2 && !!this.state.iscustomize === false ?
                                                <div>
                                                    {index === 0 ? <Item crmPack={crmPack} cardid={cardid} mcno={this.state.params.mcno} /> : ''}
                                                    {index === 1 ? <Item mpPack={mpPack} cardid={cardid} mcno={this.state.params.mcno} /> : ''}    }
                                                    </div>
                                                : ''
                                        }

                                        {
                                            tabs2.length === 1 ?
                                                <div>
                                                    {index === 0 ? <Item mpPack={mpPack} cardid={cardid} mcno={this.state.params.mcno} /> : ''}
                                                </div>
                                                : ''
                                        }

                                    </div>
                                ))
                            }
                        </Tabs>
                        : ''}
            </div>
        </div>;
    }

}